import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProductsPage } from './pages/ProductsPage';
import { InventoryPage } from './pages/InventoryPage';
import { OrdersPage } from './pages/OrdersPage';
import { ReportsPage } from './pages/ReportsPage';
import { ReturnsPage } from './pages/ReturnsPage';
import { UsersPage } from './pages/UsersPage';
import { DeliveryProvidersPage } from './pages/DeliveryProvidersPage';
import { ExpensesPage } from './pages/ExpensesPage';
import { ExpenseCategoryManagementPage } from './pages/ExpenseCategoryManagementPage';
import { FinancialPage } from './pages/FinancialPage';
import { BuyStockPage } from './pages/BuyStockPage';
import { SellStockPage } from './pages/SellStockPage';
import { ReturnStockPage } from './pages/ReturnStockPage';
import { Toaster } from 'sonner';
import './index.css';

// Role constants for easy maintenance
const ALL_ROLES = ['ADMIN', 'WAREHOUSE_STAFF', 'ORDER_CONFIRMATION', 'ACCOUNTANT', 'TYPE_A'];

function App() {
  return (
    <ThemeProvider defaultTheme="dark">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <div className="min-h-screen bg-background text-foreground">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute allowedRoles={ALL_ROLES}>
                      <DashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/orders"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'ORDER_CONFIRMATION', 'TYPE_A']}>
                      <OrdersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/products"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'WAREHOUSE_STAFF', 'TYPE_A']}>
                      <ProductsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/inventory"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'WAREHOUSE_STAFF', 'TYPE_A']}>
                      <InventoryPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/buy-stock"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'TYPE_A']}>
                      <BuyStockPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/sell-stock"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'ORDER_CONFIRMATION', 'TYPE_A']}>
                      <SellStockPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/return-stock"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'ORDER_CONFIRMATION', 'TYPE_A']}>
                      <ReturnStockPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/returns"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'WAREHOUSE_STAFF', 'TYPE_A']}>
                      <ReturnsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'ACCOUNTANT']}>
                      <ReportsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/delivery-providers"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN']}>
                      <DeliveryProvidersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/expenses"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'ACCOUNTANT', 'TYPE_A']}>
                      <ExpensesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/expense-categories"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'ACCOUNTANT']}>
                      <ExpenseCategoryManagementPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/financial"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN', 'ACCOUNTANT', 'TYPE_A']}>
                      <FinancialPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <ProtectedRoute allowedRoles={['ADMIN']}>
                      <UsersPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
              <Toaster richColors position="top-right" />

            </div>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;

